export default __webpack_public_path__ + "static/media/templates-empty-state.cdf6ad89.svg";